import React, { Suspense, lazy } from "react";
import { DA_PageNotFound } from "@danishagro/shared/src/components/organisms/PageNotFound/PageNotFound.component";
import DA_HomePage from "./Home.page";

const DA_PlaceholderPage = lazy(
    () => import(/* webpackChunkName: "PlaceholderPageChunk" */ "./Placeholder.page")
);
const DA_CartPage = lazy(() => import(/* webpackChunkName: "CartPageChunk" */ "./Cart.page"));
const DA_CheckoutPage = lazy(
    () => import(/* webpackChunkName: "CheckoutPageChunk" */ "./Checkout.page")
);
const DA_SteppedCheckoutPage = lazy(
    () =>
        import(
            /* webpackChunkName: "SteppedCheckoutPageChunk" */ "./SteppedCheckoutPage/SteppedCheckout.page"
        )
);
const DA_FavoritesPage = lazy(
    () => import(/* webpackChunkName: "FavoritesPageChunk" */ "./Favorites.page")
);
const DA_ReceiptPage = lazy(
    () => import(/* webpackChunkName: "ReceiptPageChunk" */ "./Receipt.page")
);
const DA_FarmInTimePage = lazy(
    () => import(/* webpackChunkName: "FarmInTimePageChunk" */ "./FarmInTime.page")
);
const DA_FarmInTimeCheckoutPage = lazy(
    () => import(/* webpackChunkName: "FarmInTimeCheckoutPageChunk" */ "./FarmInTimeCheckout.page")
);
const DA_SearchResultsPage = lazy(
    () => import(/* webpackChunkName: "SearchResultsPageChunk" */ "./SearchResults.page")
);

const suspense = (element: React.ReactNode) => (
    <Suspense fallback={<div className="page-container" />}>{element}</Suspense>
);

/**
 * Preview-only route component.
 * Reads the page alias from globalThis.pageContent (server-injected draft data) and
 * dispatches to the correct page component, mirroring the routes in App.tsx.
 * Data is served by getPage() which bypasses the API fetch when isPreview is true.
 */
const DA_PreviewPage = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pageContent = (globalThis as any).pageContent;

    if (!pageContent) return <DA_PageNotFound code={404} />;

    // Normalize to lowercase so "frontPage" and "frontpage" both match.
    const alias = (pageContent.alias || pageContent.pageAlias || "").toLowerCase();

    switch (alias) {
        case "frontpage":
            return <DA_HomePage />;
        case "cartpage":
            return suspense(<DA_CartPage />);
        case "checkoutpage":
            return suspense(<DA_CheckoutPage />);
        case "steppedcheckoutpage":
            return suspense(<DA_SteppedCheckoutPage />);
        case "favoritespage":
            return suspense(<DA_FavoritesPage />);
        case "receiptpage":
            return suspense(<DA_ReceiptPage />);
        case "farmintimepage":
            return suspense(<DA_FarmInTimePage />);
        case "farmintimecheckoutpage":
            return suspense(<DA_FarmInTimeCheckoutPage />);
        case "searchresultspage":
            return suspense(<DA_SearchResultsPage />);
        case "page":
        default:
            // DA_PlaceholderPage dispatches by alias: page->DA_GenericPage,
            // Product->DA_ProductPage, ProductGroup->DA_CategoryPage
            return suspense(<DA_PlaceholderPage />);
    }
};

export default DA_PreviewPage;
